import { GLOBAL_AGENTS_SID } from "@app/types/assistant/assistant";

export const MEMOAIR_AVATAR_URL =
  "/static/systemavatar/memoair_avatar_full.png";
// The Claude mark, not Anthropic's: `claude_avatar_full.png` is the Anthropic wordmark despite
// its name, and a connected agent is Claude Code rather than the company.
export const CLAUDE_AVATAR_URL =
  "/static/systemavatar/claude_code_avatar_full.svg";
export const GUIDE_AVATAR_URL = "/static/systemavatar/guide_avatar_full.svg";

const fridayAgentSIds = new Set<string>([
  GLOBAL_AGENTS_SID.DUST,
  GLOBAL_AGENTS_SID.DEEP_DIVE,
  GLOBAL_AGENTS_SID.DUST_EDGE,
]);

const agentParticipantPrefix = "agent_";

function canonicalAgentSId(sId: string): string {
  return sId.startsWith(agentParticipantPrefix)
    ? sId.slice(agentParticipantPrefix.length)
    : sId;
}

export function isFridayAgent(agent: {
  sId: string;
  name?: string | null;
}): boolean {
  if (fridayAgentSIds.has(canonicalAgentSId(agent.sId))) {
    return true;
  }
  const name = agent.name?.trim().toLowerCase();
  return name === "friday" || (name?.startsWith("friday") ?? false);
}

export function agentAvatarVisual(agent: {
  sId: string;
  name?: string | null;
  pictureUrl?: string | null;
}): string | undefined {
  // Memoair's own agents get the name-seeded illustration, not the brand mark.
  if (isFridayAgent(agent) || agent.pictureUrl === MEMOAIR_AVATAR_URL) {
    return undefined;
  }
  if (agent.pictureUrl?.startsWith("/static/")) {
    return agent.pictureUrl;
  }
  return undefined;
}

// If you update these colors or shades, also update the safelist pattern
// in front & sparkle tailwind.config.js to keep avatar backgrounds in the CSS output.
const TAILWIND_COLOR_NAMES = [
  "gray",
  "blue",
  "violet",
  "pink",
  "red",
  "orange",
  "golden",
  "lime",
  "emerald",
];
const TAILWIND_COLOR_SHADES = [
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
];

export const TAILWIND_BACKGROUND_COLORS: string[] =
  TAILWIND_COLOR_NAMES.flatMap((color) =>
    TAILWIND_COLOR_SHADES.map((shade) => `bg-${color}-${shade}`)
  );
